// HeyGen Avatar configurations for video call mode
// Users can add their own avatar IDs from their HeyGen dashboard

export interface HeyGenAvatarConfig {
  id: string;
  name: string;
  avatarId: string; // HeyGen avatar ID
  description: string;
  previewImage?: string;
}

// Default avatars - users can customize these with their HeyGen avatar IDs
export const heygenAvatars: HeyGenAvatarConfig[] = [
  {
    id: 'graham',
    name: 'Graham',
    avatarId: 'Graham_Chair_Sitting_public',
    description: 'Professional male sitting in chair',
  },
  {
    id: 'josh',
    name: 'Josh',
    avatarId: 'josh_lite3_20230714',
    description: 'Professional male avatar',
  },
  {
    id: 'wayne',
    name: 'Wayne',
    avatarId: 'Wayne_20240711',
    description: 'Business casual male',
  },
  {
    id: 'santa',
    name: 'Santa',
    avatarId: 'Santa_Fireplace_Front_public',
    description: 'Festive Santa by the fireplace',
  },
];

// Get avatar by ID
export const getHeyGenAvatar = (id: string): HeyGenAvatarConfig | undefined => {
  return heygenAvatars.find(a => a.id === id);
};

// Default avatar
export const DEFAULT_HEYGEN_AVATAR = heygenAvatars[0];

// LocalStorage key for user's selected avatar
export const HEYGEN_AVATAR_STORAGE_KEY = 'bigeSalesCoach_heygenAvatarId';
